class DivanoLookbook extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-lb-track]');
    this.viewport = this.querySelector('[data-lb-viewport]');
    this.pages = Array.from(this.querySelectorAll('[data-lb-page]'));
    this.index = 0;

    if (!this.track || this.pages.length === 0) return;

    this.querySelectorAll('[data-lb-prev]').forEach((btn) =>
      btn.addEventListener('click', () => this.go(this.index - 1)));
    this.querySelectorAll('[data-lb-next]').forEach((btn) =>
      btn.addEventListener('click', () => this.go(this.index + 1)));

    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { this.go(this.index - 1); }
      else if (e.key === 'ArrowRight') { this.go(this.index + 1); }
    });

    let startX = null, startY = null;
    this.viewport.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });
    this.viewport.addEventListener('touchend', (e) => {
      if (startX == null) return;
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        this.go(this.index + (dx < 0 ? 1 : -1));
      }
      startX = startY = null;
    }, { passive: true });

    this.update();
  }

  go(i) {
    this.index = Math.max(0, Math.min(this.pages.length - 1, i));
    this.update();
  }

  update() {
    this.track.style.transform = 'translateX(-' + (this.index * 100) + '%)';
    this.pages.forEach((page, i) => {
      const active = i === this.index;
      page.setAttribute('aria-hidden', active ? 'false' : 'true');
      page.querySelectorAll('a, button').forEach((el) => { el.tabIndex = active ? 0 : -1; });
    });
  }
}

if (!customElements.get('divano-lookbook')) {
  customElements.define('divano-lookbook', DivanoLookbook);
}
